export const uppercase = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
export const lowercase = "abcdefghijklmnopqrstuvwxyz";
export const numbers = "1234567890";
export const special = "!@#$%^&*(){}[]/";
